import React from "react";
import { connect } from "react-redux";
import { debug, getCompliance } from "../../utils";

function ChangeDetailsRightCard({ changelog }) {

    let overallCompliance = '';
    const rulesAffected = changelog.rulesAffected || [];

    if (changelog.pciCompliance && changelog.cisCompliance) {
        overallCompliance = getCompliance(changelog.pciCompliance, changelog.cisCompliance);
    }

    return (
        <div className="oct_description-list-card flex-grow-1">
            <ul className="oct_list list-unstyled">
                <li className="oct_item">
                    <span className="oct_title">Criticality:</span>
                    <span className="oct_specification">{changelog.criticality}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">MSB Violation:</span>
                    <span className="oct_specification">{changelog.msbViolation}</span>
                </li>

                <li className="oct_item">
                    <span className="oct_title">PCI Compliance:</span>
                    <span className="oct_specification">{changelog.pciCompliance}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">CIS Compliance:</span>
                    <span className="oct_specification">{changelog.cisCompliance}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Overall Compliance:</span>
                    <span className="oct_specification">{overallCompliance}%</span>
                </li>
                <li className="oct_item-list">
                    <span className="oct_title">Rules Affected: {rulesAffected.length === 0 ? ' none' : ''}</span>
                    <div className="oct_specifications">
                        <ul className="list-unstyled">
                            {rulesAffected
                                .map((rule, index) =>
                                    <li key={index}>{rule.name}</li>
                                )}
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ChangeDetailsRightCard mapStateToProps", state);
    const changeDetailsPage = state.changeDetailsPage;
    return {
        changelog: changeDetailsPage.changelog || {}
    };
}

export default connect(mapStateToProps)(ChangeDetailsRightCard);
